import type { Components, Theme } from '@mui/material';

export const typographyConfig: Components<Omit<Theme, 'components'>> = {
  MuiTypography: {
    defaultProps: {
      variantMapping: {
        h4Hyperlink: 'a',
        bodyMd: 'p',
        bodyLg: 'p',
        bodySm: 'p',
        captionSemibold: 'span',
        eyebrow: 'span',
        quote: 'blockquote',
        bodySmHyperlink: 'span',
        bodyHyperlink: 'p',
        chip: 'span',
        note: 'p',
      },
    },
    styleOverrides: {
      root: ({ theme }) => ({
        fontFamily: theme.typography.fontFamily,
        color: theme.palette.semantic.text.primary,
      }),
    },
  },
};
